"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Times = _interopRequireDefault(require("@decisiv/iconix/lib/components/Times"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _Button = _interopRequireDefault(require("../Button"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _Typography = require("../Typography");

var _ConfigProvider = require("../../providers/ConfigProvider");

var _canUseDOM = _interopRequireDefault(require("../../utils/canUseDOM"));

var _styles = require("./styles");

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var Drawer = function Drawer(_ref) {
  var title = _ref.title,
      description = _ref.description,
      children = _ref.children,
      onClose = _ref.onClose,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? 100 : _ref$zIndex,
      _ref$side = _ref.side,
      side = _ref$side === void 0 ? 'right' : _ref$side,
      _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? null : _ref$actions,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible;

  var _useConfig = (0, _ConfigProvider.useConfig)(),
      createPortal = _useConfig.createPortal;

  var translate = (0, _useTranslations.default)();
  var onKeyDown = (0, _react.useCallback)(function (event) {
    if (event.key === 'Escape') {
      onClose && onClose(event);
    }
  }, [onClose]); // Allow closing the modal by pressing the Escape key

  (0, _react.useEffect)(function () {
    if (visible && _canUseDOM.default) {
      document.addEventListener('keydown', onKeyDown);
      return function () {
        document.removeEventListener('keydown', onKeyDown);
      };
    } // eslint has issues with no return statement here...


    return undefined;
  }, [visible, onKeyDown]);
  var showHeader = !!onClose || !!title;
  var showFooter = actions && actions.length > 0;
  var closeBtnTooltip = translate('Close', 'drawer.closeBtnTooltip');
  var closeDrawerLabel = translate('Close Drawer', 'drawer.closeBtn');
  return createPortal(_react.default.createElement(_styles.Overlay, {
    zIndex: zIndex,
    side: side,
    visible: visible,
    "data-testid": "overlay"
  }, _react.default.createElement(_styles.Content, {
    visible: visible,
    side: side,
    "data-testid": "content"
  }, showHeader && _react.default.createElement(_styles.Header, {
    "data-testid": "drawer-header"
  }, _react.default.createElement(_Flex.default, null, title && _react.default.createElement(_styles.Title, null, title), onClose && _react.default.createElement(_Tooltip.default, {
    zIndex: 101,
    target: // eslint-disable-next-line react/jsx-wrap-multilines
    _react.default.createElement(_styles.CloseButton, {
      variant: "ghost",
      icon: _Times.default,
      onClick: onClose,
      "aria-label": closeDrawerLabel
    })
  }, closeBtnTooltip)), description && _react.default.createElement(_Typography.P, {
    shade: 1,
    paddingTop: 1
  }, description)), _react.default.createElement(_styles.Body, null, children), showFooter && _react.default.createElement(_styles.Footer, {
    "data-testid": "drawer-footer"
  }, actions && actions.map(function (action, i) {
    return _react.default.createElement(_Flex.default, {
      key: action.id,
      marginLeft: i > 0 ? 0.5 : 0
    }, _react.default.createElement(_Button.default, action));
  })))));
};

var _default = Drawer;
exports.default = _default;